
import React from 'react'
import icon from './svgs/medalGray.svg'
import { BaseIcon } from './_base'

export const MedalGrayIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
